export default __webpack_public_path__ + "static/media/Giraffe.86c7fecb.svg";